/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
// import { BHttp } from '../../service/bHTTP'
import { HttpClient } from '@angular/common/http';
import { SystemService } from '../../service/system.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class socialService {
  private systemService = new SystemService();
  private appUrl;
  private socialSentimentsUrl;
  private missionControlUrl;


  constructor(private bHttp: HttpClient) {
    this.appUrl = this.systemService.getAppUrl()
    this.socialSentimentsUrl = this.appUrl + 'social/sentiments';
    this.missionControlUrl = this.appUrl + 'social/missionControl';

  }

  getSetimentsByCategory(category) {
    return this.bHttp.post(this.socialSentimentsUrl, { 'sentimentsBy': category }).map(res => {
      if (res.hasOwnProperty && res) {
       return res;
      } else {
        return [];
      }
    }).catch(err => {
      return err;
    });
  }

  getMissionControl() {
    return this.bHttp.get(this.missionControlUrl).map(res => {
      if (res.hasOwnProperty && res)  {
        return res;
      } else {
        return [];
      }
    }).catch(err => {
      return err;
    })
  }

}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/social/social.service.ts